import React, { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import haukeApi from '../services/haukeApi';

const ProducerFeedback = () => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('');
  const [status, setStatus] = useState('open');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [cursor, setCursor] = useState(null);
  const [sort, setSort] = useState('desc');

  const filters = useMemo(() => ({ q: search, category, status, from, to, sort }), [search, category, status, from, to, sort]);

  useEffect(() => {
    loadItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const loadItems = async (nextCursor = null) => {
    try {
      setLoading(true);
      setError('');
      const params = {
        ...filters,
        limit: 100,
        cursor: nextCursor || ''
      };
      const res = await haukeApi.listProducerFeedback(params);
      setItems(res.data || []);
      setCursor(res.nextCursor || null);
    } catch (e) {
      console.error('Feedback laden fehlgeschlagen', e);
      setError(e?.message || 'Fehler beim Laden');
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  const handleMarkStatus = async (id, newStatus) => {
    try {
      await haukeApi.updateProducerFeedback(id, { status: newStatus, isResolved: newStatus === 'closed' });
      setItems(prev => prev.map(x => x.id === id ? { ...x, status: newStatus, isResolved: newStatus === 'closed' } : x));
    } catch (e) {
      alert(e?.message || 'Fehler beim Aktualisieren');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Feedback wirklich löschen?')) return;
    try {
      await haukeApi.deleteProducerFeedback(id);
      setItems(prev => prev.filter(x => x.id !== id));
    } catch (e) {
      alert(e?.message || 'Fehler beim Löschen');
    }
  };

  return (
    <div className="tasks-container">
      <div className="tasks-header">
        <h1>Producer Feedback</h1>
      </div>

      <div className="tasks-filters">
        <div className="filter-row">
          <div className="filter-group">
            <input
              type="text"
              className="search-input"
              placeholder="Suche in Nachrichten..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <i className="material-icons search-icon">search</i>
          </div>

          <select className="filter-select" value={category} onChange={(e) => setCategory(e.target.value)}>
            <option value="">Alle Kategorien</option>
            <option value="feedback">Feedback</option>
            <option value="bug">Fehler</option>
            <option value="feature">Feature</option>
            <option value="kontakt">Kontakt</option>
          </select>

          <select className="filter-select" value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="open">Nur offene</option>
            <option value="">Alle Status</option>
            <option value="open">Offen</option>
            <option value="in_progress">In Bearbeitung</option>
            <option value="closed">Geschlossen</option>
          </select>

          <input type="date" className="filter-input" value={from} onChange={(e) => setFrom(e.target.value)} />
          <input type="date" className="filter-input" value={to} onChange={(e) => setTo(e.target.value)} />

          <select className="filter-select" value={sort} onChange={(e) => setSort(e.target.value)}>
            <option value="desc">Neueste zuerst</option>
            <option value="asc">Älteste zuerst</option>
          </select>
        </div>
      </div>

      {loading ? (
        <div className="loading-state">
          <i className="material-icons">hourglass_empty</i>
          <p>Lade Feedback...</p>
        </div>
      ) : error ? (
        <div className="error-state">
          <i className="material-icons">error</i>
          <p>{error}</p>
        </div>
      ) : items.length === 0 ? (
        <div className="empty-state">
          <i className="material-icons">feedback</i>
          <h3>Kein Feedback gefunden</h3>
        </div>
      ) : (
        <div className="tasks-table-container">
          <table className="tasks-table">
            <thead>
              <tr>
                <th width="140">Datum</th>
                <th width="120">Kategorie</th>
                <th>Nachricht</th>
                <th width="220">Hof</th>
                <th width="180">Kontakt</th>
                <th width="140">Status</th>
                <th width="120">Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {items.map(item => (
                <tr key={item.id}>
                  <td>{item.createdAt ? new Date(item.createdAt._seconds ? item.createdAt._seconds * 1000 : item.createdAt).toLocaleString('de-DE') : '-'}</td>
                  <td><span className="task-type-badge">{item.category || '-'}</span></td>
                  <td>{item.message}</td>
                  <td>
                    {item.farmName ? (
                      <div>
                        <strong>{item.farmName}</strong>
                        <br />
                        <small>{item.farmId || ''}</small>
                      </div>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    {item.contactEmail ? (
                      <a href={`mailto:${item.contactEmail}`}>{item.contactEmail}</a>
                    ) : '-'}
                  </td>
                  <td>{item.status || 'open'}</td>
                  <td>
                    <div className="task-actions">
                      <button className="action-btn" title="In Bearbeitung" onClick={() => handleMarkStatus(item.id, 'in_progress')}>
                        <i className="material-icons">build</i>
                      </button>
                      <button className="action-btn" title="Schließen" onClick={() => handleMarkStatus(item.id, 'closed')}>
                        <i className="material-icons">done_all</i>
                      </button>
                      <button className="action-btn delete-btn" title="Löschen" onClick={() => handleDelete(item.id)}>
                        <i className="material-icons">delete</i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ProducerFeedback;


